<template>
    <div>
        <div class="location_css">
            <img src="../../assets/img/location.png">
            <div>当前位置：</div>
            <div @click="goSy()">首页</div>
            <div> <i class="el-icon-arrow-right"></i> </div>
            <div class="location_text">{{selectData.cultureHeadline}}</div>
        </div>
        <div class="culture_main" v-loading="loading">
            <div class="culture_left">
                <div class="culture_left_title">黄酒文化</div>


                <!-- <div style="padding-top:20px;background:#F6F6F6">
                    <div class="culture_left_item" v-for="(item,index) in newsList" :key="index" @click="selectData = item">
                        <div style="display: flex;">
                            <div class="culture_left_item_text" :class="{'culture_active':item.id == selectData.id}">
                                <i class="el-icon-caret-right" style="margin-right: 9px"></i>{{item.cultureHeadline}}
                            </div>
                        </div>
                    </div>
                </div> -->

                <div v-for="(item, index) in newsList" :key="index" @click="selectData = item">
                    <div class="category-item" :class="{'category-item-active':selectData.id == item.id}">
                        <div style="padding-left:10px;">{{item.cultureHeadline}}</div>
                        <i class="el-icon-arrow-right"/>
                    </div>
                </div>



            </div>
            <div class="culture_right">
                <div class="culture_right_title">
                    <div class="culture_right_text">
                        <img src="../../assets/img/jiu.png">
                        <div>{{selectData.cultureHeadline}}</div>
                    </div>
                </div>
                <div class="culture_right_content" v-html="selectData.cultureContent">
                    
                </div>
                <div class="culture_right_contentimg" v-if="selectData.imagesPath">
                    <img :src="selectData.imagesPath">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            storeId: 1,
            loading: false,
            newsList: [],
            selectData: {}
        }
    },
    methods: {
        //返回首页
        goSy:function(){
            this.$router.push({
                path:"/home"
            });
        },
        //获取文化
        getNewsList: function() {
            let vue = this;
            this.$axios.get("fx-web/wine/culture", { params: { Id: vue.storeId } }).then(function(resp) {
                if (resp.errcode == 0 || resp.errcode == "0") {
                    vue.newsList = resp.data;
                    if (vue.$route.query.id) {
                        for (var i = 0; i < resp.data.length; i++) {
                            if (resp.data[i].id == vue.$route.query.id) {
                                vue.selectData = resp.data[i];
                                break;
                            };
                        };
                    } else {
                        vue.selectData = resp.data[0];
                    };
                } else {
                    vue.$message.warning(resp.errtext);
                };
                vue.loading = false;
            }, function() {
                vue.loading = false;
            });
        },
    },
    mounted() {
        this.loading = true;
        this.getNewsList();
    }
}
</script>
<style lang="scss" scoped>
.category-item-active{
  color:white !important;
  background: #035AB1 !important;
}
</style>